import { of, from } from 'rxjs';
import { map, flatMap, catchError, pluck, tap, delay } from 'rxjs/operators';
import { fromJS } from 'immutable';
import queryString from 'query-string';
import axios from 'axios';
import { createErrorWithType } from './errors';
import { createDelayTimer } from './delay-timer';
var uiConfig = window.ui || {};
var API_HOST = uiConfig.apiHost || '';
var API_BASE_PATH = uiConfig.apiBasePath || process.env.REACT_APP_API_BASE_PATH;
var REQUEST_THROTTLE_TIME = 500; //ms
var calculateRequestDelay = createDelayTimer(REQUEST_THROTTLE_TIME);
export var defaultStatusToError = {
  404: function _(xhr) {
    return createErrorWithType("Request to ".concat(xhr.responseURL, " returned not found"), 'not-found');
  },
  403: function _(xhr) {
    return createErrorWithType("Insufficient permissions for call to ".concat(xhr.responseURL), "insufficient-permissions");
  },
  401: function _(xhr) {
    return createErrorWithType("Unauthorized call to ".concat(xhr.responseURL), 'unauthorized');
  },
  422: function _(xhr) {
    var response = parseResponse(xhr.response);
    return createErrorWithType(response.message || xhr.statusText, "".concat(response.code), response);
  }
};
export default function createRequest$(endpoint) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  var body = arguments.length > 2 ? arguments[2] : undefined;
  var params = arguments.length > 3 ? arguments[3] : undefined;
  var headers = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var statusToError = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : defaultStatusToError;
  var responseTimeCallback = arguments.length > 6 ? arguments[6] : undefined;
  var url = "".concat(API_HOST).concat(API_BASE_PATH, "/").concat(endpoint);
  var fullUrl = addParams(url, params);
  return of({
    url: fullUrl,
    method: method,
    headers: headers
  }).pipe(delay(calculateRequestDelay()), map(addBody(method, body)), map(addContentType(method)), flatMap(function (config) {
    return from(axios(config));
  }), catchError(function (err) {
    throw err.request ? generateErrorFromXhr(addResponseURL(err.request, fullUrl), statusToError) : createErrorWithType("Request to /".concat(endpoint, " failed: ").concat(err), err.type);
  }), tap(function (response) {
    try {
      var dateHeaderValue = response.headers['date'];

      // Date headers are in RFC 1123 format. either moment or Date.parse
      // natively handle that, so we don't need to normalise here
      if (dateHeaderValue && responseTimeCallback) {
        responseTimeCallback(dateHeaderValue);
      }
    } catch (err) {
      // the date failed to parse; just don't call the callback
    }
  }), pluck('data'), map(fromJS));
}

/*
  IE 11 does not support XMLHttpRequest.responseURL so when missing it's added manually
*/
function addResponseURL(req, url) {
  if (!req.responseURL) {
    req.responseURL = url;
  }
  return req;
}
function addParams(url, params) {
  return params ? url + (url.indexOf('?') === -1 ? '?' : '&') + queryString.stringify(params) : url;
}
function addBody(method, body) {
  return function (settings) {
    if (body === undefined) return settings;
    settings.data = body;
    return settings;
  };
}
function addContentType(method) {
  return function (settings) {
    if (method === 'GET') return settings;
    settings.headers['Content-Type'] = 'application/json';
    return settings;
  };
}
export var generateErrorFromXhr = function generateErrorFromXhr(xhr, mapping) {
  return (mapping[xhr.status] || getDefaultError)(xhr);
};
function getDefaultError(xhr) {
  return createErrorWithType("Request to ".concat(xhr.responseURL, " failed"), "unknown-error");
}
function parseResponse(response) {
  try {
    return JSON.parse(response);
  } catch (e) {
    return response;
  }
}